export enum StatusContasReceberEnum {
  EmAberto = 1,
  Recebido = 2,
  Cancelada = 3,
  RecebidoParcialmente = 4,
  Perda = 5,
  PerdaParcial = 6,
}
